// extracted by mini-css-extract-plugin
export var actionButton = "_im-0";
export var fileInput = "_im-2";
export var paperclip = "_im-1";